// extracted by mini-css-extract-plugin
export default {"container":"YSyU","input":"AiXR","searchWrapper":"B7lI"};